<template>
    <div>
        <div v-if="needFileName == 1" class="flex flex_between" style="padding: 5px 30px">
            <label class="inline">名称</label>
            <Input  placeholder="请输入文件名称" v-model="fileName" style="width: 200px;"></Input>
            <div class="upload-text"></div>
        </div>
        <div class="flex flex_between" style="padding: 5px 30px">
            <label class="inline">文件</label>
            <Input disabled  placeholder="请选择文件" v-model="fileUrl" style="width: 200px;"></Input>
            <Upload ref="upload" class="upload-text" :max-size="20480"
                    :format="fileFormat"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :on-success="uploadFile" :action="actionUrl">上传</Upload>
        </div>
    </div>
</template>

<script>
    import config from '../../config';
    export default{
        name:"addFile",
        props: {
            needFileName: {
                type: Number,
                default: 1,
            },
            fileFormat: {
                type: Array,
                default: ['jpg','jpeg','png','gif','doc','docx','pdf','mp3','mp4']
            }
        },
        data() {
            return {
                actionUrl: '',
                fileName: '',
                fileUrl: '',
            }
        },
        created() {
            this.actionUrl = 'https://record.jzgloan.com/app/api/uploadFile';
        },
        methods:{
            clear() {
                this.fileName = '';
                this.fileUrl = '';
                this.$refs['upload'].clearFiles();
            },
            uploadFile(e) {
                var that = this;
                if (e.code != 1) {
                    that.$Message.warning(e.msg);
                    return ;
                }
                that.fileUrl = e.data.url;
            },
            handleFormatError (file) {
                this.$Notice.warning({
                    title: 'The file format is incorrect',
                    desc: '文件类型不正确.'
                });
            },
            handleMaxSize (file) {
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    desc: '文件大小超出2M.'
                });
            },
        }
    }
</script>

<style scoped lang="less">
    .flex_between {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
    }
    .inline {
        display:inline-block;
    }
    .upload-text {
        display:inline-block; width: 120px; padding-top: 10px; color: #54A1F3; font-size: 13px
    }
</style>
